import { IPreviewListFile, } from 'atlas-shared';
import { RestRequest, } from '@Utils/rest';

export * from './abstract/list_file.api.abstract';

export const getListPreview = (file_list_id: IPreviewListFile['id']): Promise<Array<Array<any>>> => {
  return RestRequest.get(`list_file/${file_list_id}/filename/preview`);
};
